import { fetchData } from '../utils';

/**
 * API Services
 *
 * @export
 * @class BackendService
 */
class BackendService {
  constructor() {
    // INFO: config de la URL de la API, la opción por la variable window es en caso
    // de que Kubernetes setee las vars despues del build que ya usa el process.env
    this.apiURL = process.env.TBX_API_URL || (window.AppENV && window.AppENV.API_URL);

    this.getData = this.getData.bind(this);
    this.getPinForAuthorize = this.getPinForAuthorize.bind(this);
  }

  /**
   * Service call
   *
   * @returns {Promise} Respuesta del endpoint
   * @memberof BackendService
   */
  getData() {
    const options = {
      credentials: 'include',
      method: 'get',
      headers: {
        Accept: 'application/json'
      }
    };
    let url = '/getData';

    if (this.apiURL) {
      url = `${this.apiURL + url}`;
    }

    return fetchData(url, options);
  }

  getPinForAuthorize() {
    const options = {
      credentials: 'include',
      method: 'get',
      headers: {
        Accept: 'application/json'
      }
    };
    let url = '/getData';

    if (this.apiURL) {
      url = `${this.apiURL + url}`;
    }

    /**
     *
     * Insertar a continuacion la linea de codigo para hacer el fetch
     *
     */

    return {
      result: {
        ok: true,
        options,
        url
      }
    };
  }

  getCodeOfAuthorize() {
    const options = {
      credentials: 'include',
      method: 'get',
      headers: {
        Accept: 'application/json'
      }
    };
    let url = '/getData';

    if (this.apiURL) {
      url = `${this.apiURL + url}`;
    }

    /**
     *
     * Insertar a continuacion la linea de codigo para hacer el fetch
     *
     */

    return {
      result: {
        ok: true,
        options,
        url
      }
    };

  }

}

export default new BackendService();



// WEBPACK FOOTER //
// ./src/services/BackendService.js